<template>
     <v-content>
        <v-app>
            <v-container grid-list-xl text-xs-center fluid class="container-transactions-volume">
                <v-layout v-if="defaultSelect && merchant.length > 1" wrap align-center>
                    <v-flex xs4 sm4 d-flex>
                        <v-select v-model="defaultSelect" :items="merchant" @change="getReport()" item-text="name" item-value="uuid" label="Companies"></v-select>
                    </v-flex>

                    <!-- <v-spacer></v-spacer>
                    <v-flex xs2 text-xs-right>
                        <v-btn class="downloadBtn" v-if="!download" color="primary" fab small dark @click="downloadReport(); download = true;">
                            <v-icon>mdi-download</v-icon>
                        </v-btn>
                        <v-progress-circular v-else class="downloadProgress" indeterminate color="primary"></v-progress-circular>
                    </v-flex> -->
                </v-layout>

                 <v-layout row wrap align-center>
                    <v-flex xs12>
                        <v-data-table class="elevation-1" :headers="tableHeaders" :items="report" :loading="loading" :rows-per-page-items="rowsPerPage">
                            <template v-slot:items="props">
                                <td class="text-xs-left">{{ props.item.reference }}</td>
                                <td class="text-xs-left">{{ props.item.holder }}</td>
                                <td class="text-xs-center">{{ props.item.bin }}</td>
                                <td class="text-xs-center">{{ props.item.last4Digits }}</td>
                                <td class="text-xs-center">{{ props.item.expiry }}</td>
                                <td class="text-xs-center">{{ new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(props.item.successfulDebit) }}</td>
                                <td class="text-xs-center">{{ new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(props.item.failedDebit) }}</td>
                                <td v-if="props.item.paymentBrand == 'VISA' && props.item.paymentType != '3D'" class="text-xs-left">
                                    <div class="visa payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'VISAELECTRON' || props.item.paymentBrand == 'VISADEBIT'" class="text-xs-left">
                                    <div class="visa payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'MASTER' && props.item.paymentType != '3D'" class="text-xs-left">
                                    <div class="mastercard payment-brand"></div>
                                </td>
                                <td v-else class="payment-brand-text">{{ props.item.paymentBrand }}</td>
                                <td class="text-xs-center">{{ props.item.hits }}</td>
                                <td class="text-xs-center">{{ props.item.successfulHits }}</td>
                                <td class="text-xs-center">{{ props.item.failedHits }}</td>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
     </v-content>
</template>

<script>
import axios from 'axios';

export default {
        data() {
            return {
                loading: true,
                report: [],
                rowsPerPage:[10, 25, 50, 100],
                tableHeaders: [{ text: 'Reference', value: 'reference', sortable: false },
                               { text: 'Card Holder', value: 'holder', sortable: false },
                               { text: 'BIN', value: 'bin', sortable: false, align: "center" },
                               { text: 'Last 4 Digits', value: 'last4Digits', sortable: false, align: "center" },
                               { text: 'Expiry Date', value: 'expiry', sortable: false, align: "center" },
                               { text: 'Successful Debit', value: 'successfulDebit', sortable: false, align: "center" },
                               { text: 'Failed Debit', value: 'failedDebit', sortable: false, align: "center" },
                               { text: 'Payment Brand', value: 'paymentBrand', sortable: false, align: "center" },
                               { text: 'Attempts', value: 'hits', sortable: false, align: "center" },
                               { text: 'Successful', value: 'successfulHits', sortable: false, align: "center" },
                               { text: 'Failed', value: 'failedHits', sortable: false, align: "center" }],
                download: false,
                defaultSelect: null,
                merchant: [],
                merchantId: null,
                userId: localStorage.user_id,
            }
        },
        beforeMount() {
            this.getMerchants();
        },
        methods: {
            getReport() {
                this.loading = true;
                this.merchantId = typeof this.defaultSelect == 'object' ? this.merchantId : this.defaultSelect;

                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/get-card-attempts',
                data: { merchantUuid: this.merchantId },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.loading = false;
                    this.report = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            getMerchants() {
                axios({
                method: 'post',
                data: { userId: localStorage.user_id },
                url: 'https://controlapi.totalprocessing.com/api/client-get-merchant',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.merchant = response.data;
                    this.defaultSelect = this.merchant[0];
                    this.merchantId = this.merchant[0].uuid;
                    this.getReport();
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            downloadReport() {
                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/get-transactions-volume-pdf',
                data: { fromDate: this.dates.fromDate, toDate: this.dates.toDate },
                responseType: 'blob',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'transactions-volume-report.csv');
                    document.body.appendChild(link);
                    link.click();
                    this.download = false;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
        }
}
</script>

<style scoped>
.downloadBtn, .downloadProgress {
    width: 36px !important;
    height: 36px !important;
    margin-top: 0px !important;
}
</style>
